import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

/**
 * Redirects the user after signup
 *
 * @param {*} param0
 */
const LoginRouter = ({
  signedUp,
  newTeam,
  existingUser,
  loggedIn,
  children,
}) => {
  useEffect(() => {
    if (signedUp && newTeam && !existingUser) {
      window.location.assign('/dash/redirect/new');
      return;
    }
    if (signedUp && !existingUser) {
      window.location.assign('/dash/redirect');
      return;
    }

    if (signedUp && newTeam && existingUser) {
      window.location.assign(`/dash/team/${newTeam._id}`);
      return;
    }

    if (loggedIn || existingUser) {
      if (window.location.href.includes('redirect')) {
        const url = new URL(window.location.href);
        let redirectURL;
        redirectURL = new URL(url.searchParams.get('redirect'));

        if (redirectURL.host === url.host) {
          return window.location.assign(redirectURL.href);
        }
      } else {
        window.location.assign('/dash/redirect');
      }
    }
  }, [loggedIn, signedUp, newTeam, existingUser]);

  return <>{children}</>;
};

LoginRouter.propTypes = {
  signedUp: PropTypes.bool,
  newTeam: PropTypes.object,
  existingUser: PropTypes.object,
  loggedIn: PropTypes.bool,
  children: PropTypes.element,
};

export default connect(
  ({ loggedIn, signedUp, newUser, newTeam, existingUser }) => {
    return {
      loggedIn,
      signedUp,
      newUser,
      newTeam,
      existingUser,
    };
  }
)(LoginRouter);
